import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { isNotLoginOrExpired } from '../../../../helpers/Common';
import EventEmitter, {
  SHOW_GUEST_POPUP,
} from '../../../../helpers/EventEmitter';

const LIST_TAB = {
  'priceDepth.action.lvl1': 1,
  'priceDepth.action.lvl2': 2,
};

class SwitchTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        { value: 'priceDepth.action.lvl1' },
        { value: 'priceDepth.action.lvl2' },
      ],
    };
  }

  componentDidMount() {
    const { currentTab, user } = this.props;
    const isLocked = isNotLoginOrExpired(user) && currentTab === 2;
    if (isLocked) {
      this.onclickTab('priceDepth.action.lvl1');
    }
  }

  isLocked = value => {
    const { user } = this.props;

    return isNotLoginOrExpired(user) && value === 'priceDepth.action.lvl2';
  };

  onclickTab = value => {
    const { changeTab } = this.props;
    if (this.isLocked(value)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }

    changeTab(LIST_TAB[value]);
  };

  render() {
    const { currentTab } = this.props;
    const { listTab } = this.state;
    return (
      <div className="switch-tab-wrapper">
        {listTab.map(({ value }, index) => {
          return (
            <div
              key={value}
              className={`level-item ${index === 0 ? 'mr-3' : ''}`}
              onClick={() => this.onclickTab(value)}
            >
              <div
                className={`${
                  currentTab === LIST_TAB[value]
                    ? 'level-item__title'
                    : 'level-item__title level-item__title--grey'
                }`}
              >
                {<Translate value={value} />}
                {this.isLocked(value) && <i className="icon-padlock" />}
              </div>
              <div
                className={`${
                  currentTab === LIST_TAB[value]
                    ? 'level-item__underline level-item__underline--selected'
                    : 'level-item__underline'
                }`}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

export default connect(mapStateToProps)(SwitchTab);
